export default __webpack_public_path__ + "static/media/ClubEZ-banner.4882f336.png";